module.exports = __webpack_public_path__ + "img/react.277f5ed3.jpeg";